export interface ProductPopularityEntry {
  id: number;
  order?: number;
}

export const productPopularityEntryToUpdateRequest = (
  entry: ProductPopularityEntry,
) => ({
  id: entry.id,
  order: entry.order ?? null,
});
